import { useState } from "react";
import useMerchantPortalAxios, {
  useMerchantPortalFormData,
} from "../utils/axios";
// import { learesponse } from "../layoushresponse";
import { useDispatch, useSelector } from "react-redux";
import { settingData } from "../features/legalEnrollmentSlice";
import useMerchantPortalIVSAxios from "../utils/ivsaxios";
import axios from "axios";
import useResponse from "../app/useResponse";

const MerchantEnrollmentAPI = () => {
  const dispatch = useDispatch();

  //   //here:
  //   let newresponse = learesponse;
  //   const [autofillData, setAutofillData] = useState(
  //     newresponse?.resource?.payload
  //   );

  const { successResponse, errorResponse } = useResponse();

  const [autofillData, setAutofillData] = useState(null);
  const [employeesList, setEmployeesList] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [categoriesList, setCategoriesList] = useState(null);
  const [subCategoriesList, setSubCategoriesList] = useState(null);
  const [districtsList, setDistrictsList] = useState(null);
  const [citiesList, setCitiesList] = useState(null);
  const [webProvidersList, setWebProvidersList] = useState(null);
  const [response, setResponse] = useState(null);

  const [progress, setProgress] = useState(0);

  const MerchantPortalAxios = useMerchantPortalAxios();
  const MerchantPortalAxisFormData = useMerchantPortalFormData();
  const MerchantPortalIVSAxios = useMerchantPortalIVSAxios();
  const enrollementFlowid = useSelector(
    (s) => s?.legalEnrollment?.enrollementFlowid,
  );

  const GetCorporateFlowId = async () => {
    const res = await MerchantPortalAxios.post(
      `v1/MerchantEnrollment/GetCorporateFlowId`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
        VerificationRef: sessionStorage.getItem("RegCodUrl"),
      },
    );

    dispatch(
      settingData({
        field: `enrollementFlowid`,
        value: res?.data?.Payload?.FlowId,
      }),
    );

    return {
      flowid: res?.data?.Payload?.FlowId,
      remoteId: res?.data?.Payload?.Remoteid,
    };
  };

  const CorporateAutoFillData = async (step28 = false) => {
    const code = sessionStorage.getItem("RegCodUrl");
    const res = await MerchantPortalIVSAxios.get(
      `GetFieldValue?VerificationRef=${code}`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
      },
    );

    dispatch(
      settingData({
        field: "corporatedata",
        value: res?.data?.resource?.payload,
      }),
    );

    // dispatch(
    //   settingData({
    //     field: "verificationRef",
    //     value: res?.data?.resource?.payload?.verificationRef,
    //   })
    // );

    dispatch(
      settingData({
        field: "remoteID",
        value: res?.data?.resource?.payload?.remoteID,
      }),
    );

    if (step28) {
      dispatch(
        settingData({
          field: "finalStep",
          value: res?.data?.resource?.payload,
        }),
      );
    }

    setAutofillData(res?.data?.resource?.payload);

    return {
      remoteID: res?.data?.resource?.payload?.remoteID,
      verificationRef: res?.data?.resource?.payload?.verificationRef,
    };
  };

  const PerformAction = async (verificationRef, remoteID, flowID) => {
    const body = {
      flowID,
      clientID: 1,
      verificationRef: verificationRef,
      remoteID: remoteID,
      languageID: 1,
    };
    const res = await MerchantPortalIVSAxios.post(
      `PerformCorporateAction`,
      body,
    );
    if (res.data.success) {
      // clone payload and remove last step
      const payload = {
        ...res.data.resource.payload,
        steps: res.data.resource.payload.steps.slice(0, -1),
      };

      dispatch(
        settingData({
          field: "performcorporateaction",
          value: payload,
        }),
      );

      dispatch(
        settingData({
          field: "stepid",
          value: payload.steps[0]?.stepID,
        }),
      );

      dispatch(
        settingData({
          field: "initialStepId",
          value: payload.steps[0]?.stepID,
        }),
      );

      dispatch(
        settingData({
          field: "verificationRef",
          value: payload.verificationRef,
        }),
      );
    } else {
      console.log("error");
    }
    return;
  };

  const GetFieldsByStepId = async (stepid, verificationid) => {
    const res = await MerchantPortalIVSAxios.get(
      `GetFieldsByStepId?StepId=${stepid}&DocumentId=0&VerificationRef=${verificationid}`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
      },
    );

    dispatch(
      settingData({
        field: `getfieldByStepId`,
        value: res?.data?.resource?.payload,
      }),
    );

    return {
      response: res?.data?.resource?.payload,
    };
  };

  const GetCountries = async (verificationRef) => {
    const body = {
      verificationRef,
    };
    const res = await MerchantPortalIVSAxios.get(`GetAllCountries`, {
      params: {
        VerificationRef: verificationRef,
      },
    });

    dispatch(
      settingData({
        field: "allcountries",
        value: res?.data?.resource?.payload?.countries,
      }),
    );

    const filteredCountries = res?.data?.resource?.payload?.countries?.filter(
      (country) => country.id !== 158,
    );

    dispatch(
      settingData({
        field: "countries",
        value: {
          ...res?.data?.resource?.payload,
          countries: filteredCountries,
        },
      }),
    );

    return;
  };

  const SaveFieldValue = async (
    allinformation,
    stepID,
    verificationid,
    ifRemove = false,
  ) => {
    const body = {
      verificationRef: verificationid,
      stepID: stepID,
      fieldValue: allinformation,
    };

    try {
      const res = await MerchantPortalIVSAxios.post(`SaveFieldValue`, body);

      if (res.data.success && !ifRemove) {
        dispatch(
          settingData({
            field: "stepid",
            value: stepID + (enrollementFlowid === 12 ? 2 : 1),
          }),
        );
      }
    } catch (err) {
      let title = "Failed";
      let description = "Save field values failed. Please try again.";
      // try extracting backend error message
      const errorDetail = err?.response?.data?.error?.errorDetail;
      if (errorDetail?.message) {
        try {
          const parsed = JSON.parse(errorDetail.message);
          title = parsed?.Title || title;
          description = parsed?.Text || description;
        } catch {
          // fallback if parsing fails
          description = errorDetail.message;
        }
      }
      const updatedPayload = {
        isPopup: true,
        PopupDescription: description,
        PopupTitle: title,
      };

      dispatch(settingData({ field: "saveResponse", value: updatedPayload }));
      errorResponse({ response: { data: updatedPayload } });
    }

    return;
  };

  const GenerateSASuri = async () => {
    try {
      const res = await MerchantPortalIVSAxios.get("/GenerateSASuri");
      const sasUri = res?.data?.resource?.payload?.sasUri;
      if (!sasUri) throw new Error("No SAS returned");

      dispatch(settingData({ field: "sasUri", value: sasUri }));
      sessionStorage.setItem("blobToken", sasUri);
      return sasUri;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const uploadImage = async (formData) => {
    try {
      const res = await axios.post(
        "https://suyool.com/api/upload-image",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      return res.data;
    } catch (err) {
      console.error("Upload error:", err);
      throw err;
    }
  };

  const SaveCorporateEnrollmentEntityData = async (
    VerificationRef,
    Documents,
    OnBoardID,
  ) => {
    const body = {
      IbanApplication:
        sessionStorage.getItem("applyToIban") == 1 ? true : false,
      SessionID: sessionStorage.getItem("SessionID"),
      OnBoardID,
      VerificationRef,
      Documents,
    };
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/MerchantEnrollment/SaveCorporateEnrollmentEntityData",
        body,
      );

      if (res.data?.Payload?.GlobalCode == 0) {
        const updatedPayload = {
          ...res.data.Payload,
          isPopup: true,
          Message:
            "Once the information is confirmed, you will receive an email to start adding your branches",
          Title: "Application successfully sent",
        };
        dispatch(settingData({ field: "saveResponse", value: updatedPayload }));
        dispatch(settingData({ field: "suyoolredirect", value: true }));
        successResponse(updatedPayload, true);
      }

      if (res.data?.Payload?.GlobalCode == 1) {
        const updatedPayload = {
          ...res.data.Payload,
          isPopup: true,
          PopupDescription: res.data?.Payload?.FlagDesc,
          PopupTitle: "Failed",
        };
        dispatch(settingData({ field: "saveResponse", value: updatedPayload }));
        errorResponse({ response: { data: updatedPayload } });
      }
    } catch (err) {
      const updatedPayload = {
        isPopup: true,
        PopupDescription: "Submission Failed",
        PopupTitle: "Failed",
      };

      dispatch(settingData({ field: "saveResponse", value: updatedPayload }));
      errorResponse({ response: { data: updatedPayload } });
    }
  };

  const GetEmployeeNames = async (EmployeeListInfo) => {
    const res = await MerchantPortalAxios.post(
      "/v1/MerchantEnrollment/GetEmployeeNames",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        EmployeeListInfo,
      },
    );

    setEmployeesList(res.data.Payload);
  };

  const SaveCorporateEnrollmentData = async (payload) => {
    try {
      setUploadLoading(true);
      const res = await MerchantPortalAxisFormData.post(
        "/v1/MerchantEnrollment/SaveCorporateEnrollmentData",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          ...payload,
        },
        {
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            let percent = Math.floor((loaded * 100) / total);
            setProgress(percent);
          },
        },
      );

      return res;
    } catch (error) {
      setProgress(0);
    }
  };

  const GetCategories = async () => {
    const res = await MerchantPortalAxios.get(
      "/v1/MerchantEnrollment/GetCategories",
    );

    setCategoriesList(res.data);
  };

  const GetSubCategories = async (CategoryID) => {
    const res = await MerchantPortalAxios.post(
      "/v1/MerchantEnrollment/GetSubCategories",
      {
        CategoryID,
      },
    );

    setSubCategoriesList(res.data);
  };

  const GetDistricts = async () => {
    const res = await MerchantPortalAxios.get(
      "/v1/MerchantEnrollment/GetDistricts",
    );

    setDistrictsList(res.data);
  };

  const GetCities = async (DistrictID) => {
    const res = await MerchantPortalAxios.post(
      "/v1/MerchantEnrollment/GetCities",
      {
        DistrictID,
      },
    );

    setCitiesList(res.data);
  };

  const GetWebsiteProviders = async () => {
    const res = await MerchantPortalAxios.get(
      "/v1/MerchantEnrollment/GetWebsiteProviders",
    );

    setWebProvidersList(res.data);
  };

  const SaveMerchantEnrollmentData = async (payload) => {
    try {
      setUploadLoading(true);
      const res = await MerchantPortalAxisFormData.post(
        "/v1/MerchantEnrollment/SaveMerchantEnrollmentData",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          ...payload,
        },
        {
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            let percent = Math.floor((loaded * 100) / total);
            setProgress(percent);
          },
        },
      );

      if (res.data.Payload) {
        setResponse(res.data.Payload);
      }

      setUploadLoading(false);
    } catch (error) {
      console.error(
        "An error occurred while saving merchant enrollment data:",
        error,
      );
      setUploadLoading(false);
      // Handle the error as needed, you might want to set an error state or display a message to the user.
    }
  };

  return {
    CorporateAutoFillData,
    GetEmployeeNames,
    SaveCorporateEnrollmentData,
    GetCategories,
    GetSubCategories,
    GetDistricts,
    GetCities,
    GetWebsiteProviders,
    SaveMerchantEnrollmentData,
    setUploadLoading,
    employeesList,
    autofillData,
    uploadLoading,
    categoriesList,
    subCategoriesList,
    districtsList,
    citiesList,
    webProvidersList,
    response,
    progress,
    setProgress,
    PerformAction,
    GetCountries,
    GetFieldsByStepId,
    SaveFieldValue,
    SaveCorporateEnrollmentEntityData,
    GenerateSASuri,
    uploadImage,
    GetCorporateFlowId,
  };
};

export default MerchantEnrollmentAPI;
